import React from 'react';
import Grid  from '@material-ui/core/Grid';

export default function GridItem({children, ...props }) {
  return (
    <Grid item {...props} >
      {children}
    </Grid>
  );
}
